module.exports = __webpack_public_path__ + "img/car-b.f65b0ebc.png";